module.exports = __webpack_public_path__ + "static/media/inventory.5f5fc122.png";